<h1 mat-dialog-title>{{"Passwort ändern" | translate : "header-headline" }}</h1>
<mat-dialog-content>
  <form class="form" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
			<app-shared-caps-lock-notice class="caps-lock-notice"/>
      <mat-form-field>
        <mat-label>{{"Aktuelles Passwort" | translate : "input-current-password"}}</mat-label>
        <input autocomplete="current-password" cdkFocusInitial matInput [type]="hideCurrentPassword() ? 'password' : 'text'" formControlName="currentPassword"/>
        <div matSuffix class="suffix-container">
          <div class="icon-container">
            <ogs-m3-icon matIconSuffix prefix="fal" icon="circle-exclamation" class="error-icon content" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="this.hideCurrentPassword.set(!this.hideCurrentPassword())"
														tabindex="-1"
            >
              <ogs-m3-icon prefix="fal" [icon]="hideCurrentPassword() ? 'eye' : 'eye-slash'" />
            </button>
          </div>
        </div>
      </mat-form-field>

      <p>{{"Das neue Passwort muss mindestens 8 Zeichen lang sein.\nEs muss mindestens 1 Großbuchstaben sowie 1 Kleinbuchstaben beinhalten." | translate : "paragraph-password-format"}}</p>

								@if(isPasswordSuccessfullyChanged()){
									<app-shared-notify-chip status="success">
										<ogs-m3-icon prefix="fal" icon="exclamation-triangle"/>
											<app-shared-notify-chip-value>
												{{"Passwort erfolgreich geändert" | translate : "status-password-changed-successfully"}}
											</app-shared-notify-chip-value>
									</app-shared-notify-chip>
								}
								@else {
									     <div formGroupName="newPasswordGroup" class="new-password-container">
							@if(hasServerError()){
										<app-shared-notify-chip status="error">
									<ogs-m3-icon prefix="fal" icon="exclamation-triangle"/>
									<app-shared-notify-chip-value>
										{{serverErrorMessage().defaultText | translate: serverErrorMessage().token}}
									</app-shared-notify-chip-value>
								</app-shared-notify-chip>
							}
						
        <mat-form-field class="conditional-suffix">
          <mat-label>{{"Neues Passwort" | translate : "input-new-password"}}</mat-label>
          <input autocomplete="new-password" matInput [type]="hideNewPassword() ? 'password' : 'text'" formControlName="newPassword"/>
          @if (newPassword.hasError('format') || newPassword.hasError('minlength')) {
            <mat-error>{{"Passwort entspricht nicht den Anforderungen" | translate : "input-error-password-wrong-format"}}</mat-error>
          }
          <div matSuffix class="suffix-container">
            <div class="icon-container">
              <ogs-m3-icon matIconSuffix prefix="fal" icon="circle-exclamation" class="error-icon content" />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="this.hideNewPassword.set(!this.hideNewPassword())"
																tabindex="-1"
              >
                <ogs-m3-icon prefix="fal" [icon]="hideNewPassword() ? 'eye' : 'eye-slash'" />
              </button>
            </div>
          </div>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"Neues Passwort wiederholen" | translate : "input-new-password-repeat"}}</mat-label>
          <input autocomplete="new-password" matInput [type]="hideNewPasswordRepeat() ? 'password' : 'text'" formControlName="newPasswordRepeat"/>
          @if (newPasswordRepeat.hasError('match')) {
            <mat-error>{{"Passwort stimmt nicht überein" | translate : "input-new-password-repeat-error"}}</mat-error>
          }
          <div matSuffix class="suffix-container">
            <div class="icon-container">
              <ogs-m3-icon matIconSuffix prefix="fal" icon="circle-exclamation" class="error-icon content" />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="this.hideNewPasswordRepeat.set(!this.hideNewPasswordRepeat())"
																tabindex="-1"
              >
                <ogs-m3-icon prefix="fal" [icon]="hideNewPasswordRepeat() ? 'eye' : 'eye-slash'" />
              </button>
            </div>
          </div>
        </mat-form-field>
      </div>
								}
 

				<!-- <mat-divider /> -->
    
					@if(isPasswordSuccessfullyChanged()){
						<div class="button-container button-container--success">
																 <button mat-flat-button
              [mat-dialog-close]="true"
														class="button--surface">
														<div>
																<ogs-m3-icon prefix="fal" icon="xmark"/> 
														<span>{{"Schließen" | translate : "action-close"}}</span>
														</div>
      </button>				
						</div>
					}
					@else {
						<div class="button-container">
							 <button mat-flat-button
              [mat-dialog-close]="true"
														class="button--surface">
														{{"Schließen" | translate : "action-cancel"}}
      </button>
      <button mat-flat-button class="button--tertiary" [disabled]="changePasswordForm.invalid || this.hasServerError()"
              type="submit">
														{{"Passwort ändern" | translate : "action-change-password"}}
      </button>
						</div>
					}
  </form>
</mat-dialog-content>
